// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__rwvFL","burgerOpen":"Burger_burgerOpen__BaNxF"};